import { Nullable } from "src/utils";
import { client } from "src/services/client";

export const fetchContactAgent = async (query: Nullable<string>) =>
    client({
        method: "post",
        url: `/contact/agent`,
        headers: { "Content-Type": "application/json" },
        data: query,
    }).then((response) => response.data);
